import React, { useEffect, useState } from 'react'
import { getAboutUs } from '../../Services/PagesServices'
import toast from 'react-hot-toast'

const useAboutUs = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [aboutUsData, setAboutUsData] = useState(null)


    const handleAboutUs = async () => {
        setIsLoading(true)
        let response = await getAboutUs()
        if (response.statusCode === 200) {
            setAboutUsData(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        handleAboutUs()
    }, [])

    return {
        isLoading,
        aboutUsData,
        handleAboutUs
    }
}

export default useAboutUs